import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "../Login.css";
import biswabangla from "../../../assets/images/biswabangla.png";

function MunicipalityLogin() {
  const navigate = useNavigate();

  const [municipalityCode, setMunicipalityCode] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://sutmmgdev.codydeasoftech.in/api/login",
        {
          username: municipalityCode,
          password: password
        }
      );


      if (response.data.status === true) {
        const { user,user_details, token } = response.data.data;


        if (user.user_type_id === 1) {
                Swal.fire({
                    title: "Login Failed",
                    text: "Wrong User ID or Password.",
                    icon: "error",
                    confirmButtonText: "OK",
                    allowOutsideClick: true,
                    allowEscapeKey: true
                });

                return;
                }



        Swal.fire({
          title: "Login Successful",
          text: response.data.message,
          icon: "success",
          timer: 1500,
          showConfirmButton: false
        });

        // Store session
        localStorage.setItem("token", token);
        localStorage.setItem("userId", user.user_id);
        localStorage.setItem("userTypeId", user.user_type_id);
        localStorage.setItem("username", user.username);
        localStorage.setItem("name", user.name);
        localStorage.setItem("districtId",user_details.district_id);

        // Municipality specific
        localStorage.setItem("municipality_id", user.user_id);

        setTimeout(() => {
          navigate("/app/dashboard");
        }, 1200);
      } else {
        Swal.fire("Login Failed", response.data.message, "error");
      }
    } catch (error) {
      console.error("LOGIN ERROR:", error?.response?.data);

      Swal.fire(
        "Error",
        error?.response?.data?.message || "Server error occurred.",
        "error"
      );
    }
  };

  return (
    <div className="login-container">
      <form className="login-card" onSubmit={handleSubmit}>
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <img src={biswabangla} alt="logo" style={{ width: "100px" , cursor: "pointer"  }} onClick={() => navigate("/landing")} />
          <h4 style={{ fontWeight: "bold" }}>
            {/* Urban School Uniform Stitching Project Management System */}

            Smart Urban Uniform Management System
          </h4>
          <p style={{ fontSize: "14px" }}>Sponsored by WB State Govt.</p>
                    <p className="fw-bold" style={{ fontSize: "20px", color: "#3e7ff6" }}>ULB LOGIN</p>

        </div>

        {/* MUNICIPALITY CODE */}
        <div className="input-wrapper">
          <span className="icon">
            <i className="fas fa-city"></i>
          </span>
          <input
            type="text"
            placeholder="Municipality Code"
            value={municipalityCode}
            onChange={(e) => setMunicipalityCode(e.target.value)}
            required
          />
        </div>

        {/* PASSWORD */}
        <div className="input-wrapper" style={{ position: "relative" }}>
          <span className="icon">
            <i className="fas fa-key"></i>
          </span>
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <span
            className="toggle-password"
            onClick={() => setShowPassword(!showPassword)}
          >
            <i className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
          </span>
        </div>

        <button type="submit">Login</button>
      </form>
    </div>
  );
}

export default MunicipalityLogin;
